function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useRef, useState } from "react";
import ReactDOM, { flushSync } from "react-dom";
import classNames from "classnames";
import "./popup.css";
import { jsx as _jsx } from "react/jsx-runtime";
var Popup = function Popup(props) {
  var _classNames;
  var children = props.children,
    root = props.root,
    scrollRoot = props.scrollRoot,
    visibleProp = props.visible,
    onVisibleChange = props.onVisibleChange,
    _props$trigger = props.trigger,
    trigger = _props$trigger === void 0 ? "hover" : _props$trigger,
    _props$position = props.position,
    position = _props$position === void 0 ? "bottom" : _props$position,
    _props$closeOnClickTr = props.closeOnClickTrigger,
    closeOnClickTrigger = _props$closeOnClickTr === void 0 ? true : _props$closeOnClickTr,
    _props$animation = props.animation,
    animation = _props$animation === void 0 ? "Opacity" : _props$animation,
    prefixClass = props.prefixClass,
    className = props.className,
    hiddenOutView = props.hiddenOutView;
  var _useState = useState(visibleProp),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    visibleBoundary = _useState4[0],
    setVisibleBoundary = _useState4[1];
  var _useState5 = useState(visibleProp),
    _useState6 = _slicedToArray(_useState5, 2),
    isRender = _useState6[0],
    setIsRender = _useState6[1];
  var $popupPlace = useRef(null);
  var $popup = useRef(null);
  var positions = function positions() {
    var _$popupPlace$current;
    var $parent = (_$popupPlace$current = $popupPlace.current) === null || _$popupPlace$current === void 0 ? void 0 : _$popupPlace$current.parentElement;
    if (!$parent || !$popup.current) return;
    var _$parent$getBoundingC = $parent.getBoundingClientRect(),
      top = _$parent$getBoundingC.top,
      left = _$parent$getBoundingC.left,
      width = _$parent$getBoundingC.width,
      height = _$parent$getBoundingC.height;
    var width2 = $popup.current.clientWidth;
    var height2 = $popup.current.clientHeight;
    var boundary = function boundary(x, y, w, h) {
      var _x = x;
      var _y = y;
      var visibleFlag = true;
      if (_x < 0) {
        _x = 10;
        if (hiddenOutView) {
          visibleFlag = false;
        }
      }
      if (_x + w > window.innerWidth) {
        _x = window.innerWidth - w - 10;
        if (hiddenOutView) {
          visibleFlag = false;
        }
      }
      if (_y < 0) {
        _y = 10;
        if (hiddenOutView) {
          visibleFlag = false;
        }
      }
      if (_y + h > window.innerHeight) {
        _y = window.innerHeight - h - 10;
        if (hiddenOutView) {
          visibleFlag = false;
        }
      }
      setVisibleBoundary(visibleFlag);
      return {
        x: _x,
        y: _y
      };
    };
    if (position === "topLeft") {
      return boundary(left, top - height2, width2, height2);
    }
    if (position === "top") {
      return boundary(left + (width - width2) / 2, top - height2, width2, height2);
    }
    if (position === "topRight") {
      return boundary(left + (width - width2), top - height2, width2, height2);
    }
    if (position === "rightTop") {
      return boundary(left + width, top, width2, height2);
    }
    if (position === "right") {
      return boundary(left + width, top + (height - height2) / 2, width2, height2);
    }
    if (position === "rightBottom") {
      return boundary(left + width, top + (height - height2), width2, height2);
    }
    if (position === "bottomRight") {
      return boundary(left + (width - width2), top + height, width2, height2);
    }
    if (position === "bottom") {
      return boundary(left + (width - width2) / 2, top + height, width2, height2);
    }
    if (position === "bottomLeft") {
      return boundary(left, top + height, width2, height2);
    }
    if (position === "leftBottom") {
      return boundary(left - width2, top + (height - height2), width2, height2);
    }
    if (position === "left") {
      return boundary(left - width2, top + (height - height2) / 2, width2, height2);
    }
    if (position === "leftTop") {
      return boundary(left - width2, top, width2, height2);
    }
  };
  var onClose = function onClose(ev) {
    var _$popupPlace$current2, _ev$target, _ev$target$dataset, _$popup$current;
    var $parent = (_$popupPlace$current2 = $popupPlace.current) === null || _$popupPlace$current2 === void 0 ? void 0 : _$popupPlace$current2.parentElement;
    if (((_ev$target = ev.target) === null || _ev$target === void 0 ? void 0 : (_ev$target$dataset = _ev$target.dataset) === null || _ev$target$dataset === void 0 ? void 0 : _ev$target$dataset.popupClose) === "false") {
      return;
    }
    if ($parent !== null && $parent !== void 0 && $parent.contains(ev.target)) {
      return;
    }
    if ((_$popup$current = $popup.current) !== null && _$popup$current !== void 0 && _$popup$current.contains(ev.target)) {
      return;
    }
    // eslint-disable-next-line no-use-before-define
    close();
  };
  var onScroll = function onScroll() {
    var _$popup$current2, _$popup$current3;
    var pos = positions();
    (_$popup$current2 = $popup.current) === null || _$popup$current2 === void 0 ? void 0 : _$popup$current2.style.setProperty("--yk-popup-x", "".concat(pos === null || pos === void 0 ? void 0 : pos.x, "px"));
    (_$popup$current3 = $popup.current) === null || _$popup$current3 === void 0 ? void 0 : _$popup$current3.style.setProperty("--yk-popup-y", "".concat(pos === null || pos === void 0 ? void 0 : pos.y, "px"));
  };
  var open = function open() {
    var _$popup$current4, _$popup$current5, _$popup$current6, _$popup$current7;
    if (visibleProp === false && !onVisibleChange) {
      return;
    }
    if (!isRender) {
      flushSync(function () {
        setIsRender(true);
      });
    }
    setVisible(true);
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange({
      value: true
    });
    var pos = positions();
    (_$popup$current4 = $popup.current) === null || _$popup$current4 === void 0 ? void 0 : _$popup$current4.style.setProperty("--yk-popup-x", "".concat(pos === null || pos === void 0 ? void 0 : pos.x, "px"));
    (_$popup$current5 = $popup.current) === null || _$popup$current5 === void 0 ? void 0 : _$popup$current5.style.setProperty("--yk-popup-y", "".concat(pos === null || pos === void 0 ? void 0 : pos.y, "px"));
    (_$popup$current6 = $popup.current) === null || _$popup$current6 === void 0 ? void 0 : _$popup$current6.style.setProperty("--yk-popup-in", "".concat(prefixClass, "Popup").concat(animation, "In"));
    (_$popup$current7 = $popup.current) === null || _$popup$current7 === void 0 ? void 0 : _$popup$current7.style.setProperty("--yk-popup-out", "".concat(prefixClass, "Popup").concat(animation, "Out"));
    if (trigger === "hover") {
      document.addEventListener("mouseover", onClose);
    }
    document.addEventListener("click", onClose, true);
    ((scrollRoot === null || scrollRoot === void 0 ? void 0 : scrollRoot()) || window).addEventListener("scroll", onScroll);
  };
  var close = function close() {
    if (visibleProp && !onVisibleChange) {
      return;
    }
    setVisible(false);
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange({
      value: false
    });
    if (trigger === "hover") {
      document.removeEventListener("mouseover", onClose);
    }
    document.removeEventListener("click", onClose);
    ((scrollRoot === null || scrollRoot === void 0 ? void 0 : scrollRoot()) || window).removeEventListener("scroll", onScroll);
  };
  var click = function click(ev) {
    var _$popupPlace$current3, _ev$target2, _ev$target2$dataset;
    var $parent = (_$popupPlace$current3 = $popupPlace.current) === null || _$popupPlace$current3 === void 0 ? void 0 : _$popupPlace$current3.parentElement;
    if (!$parent) return;
    if (((_ev$target2 = ev.target) === null || _ev$target2 === void 0 ? void 0 : (_ev$target2$dataset = _ev$target2.dataset) === null || _ev$target2$dataset === void 0 ? void 0 : _ev$target2$dataset.popupOpen) === "false") {
      return;
    }
    if ($parent.contains(ev.target)) {
      if (visible && closeOnClickTrigger) {
        close();
      } else {
        open();
      }
    }
  };
  var clickRef = useRef(click);
  useEffect(function () {
    clickRef.current = click;
  }, [visible]);
  var onResize = function onResize() {
    var _$popup$current8, _$popup$current9;
    var pos = positions();
    (_$popup$current8 = $popup.current) === null || _$popup$current8 === void 0 ? void 0 : _$popup$current8.style.setProperty("--yk-popup-x", "".concat(pos === null || pos === void 0 ? void 0 : pos.x, "px"));
    (_$popup$current9 = $popup.current) === null || _$popup$current9 === void 0 ? void 0 : _$popup$current9.style.setProperty("--yk-popup-y", "".concat(pos === null || pos === void 0 ? void 0 : pos.y, "px"));
  };
  useEffect(function () {
    var _$popupPlace$current4;
    var $parent = (_$popupPlace$current4 = $popupPlace.current) === null || _$popupPlace$current4 === void 0 ? void 0 : _$popupPlace$current4.parentElement;
    if (!$parent) return;
    var onClick = function onClick(ev) {
      return clickRef.current(ev);
    };
    if (trigger === "hover") {
      $parent.addEventListener("mouseenter", open);
    }
    if (trigger === "click") {
      $parent.addEventListener("click", onClick);
    }
    window.addEventListener("resize", onResize);
    return function () {
      if (trigger === "hover") {
        $parent.removeEventListener("mouseenter", open);
      }
      if (trigger === "click") {
        $parent.removeEventListener("click", onClick);
      }
      window.removeEventListener("resize", onResize);
    };
  }, []);
  useEffect(function () {
    visibleProp ? open() : close();
  }, [visibleProp]);
  return /*#__PURE__*/_jsx("div", {
    ref: $popupPlace,
    style: {
      display: "contents"
    },
    children: isRender && /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsx("div", {
      className: classNames("".concat(prefixClass, "PopupContent"), "".concat(prefixClass, "PopupContent--").concat(position), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixClass, "PopupContent--hidden"), !visible || !visibleBoundary), _defineProperty(_classNames, "".concat(prefixClass, "PopupContent--visible"), visible && visibleBoundary), _classNames), className),
      ref: $popup,
      onScroll: function onScroll(ev) {
        return ev.stopPropagation();
      },
      children: children
    }), (root === null || root === void 0 ? void 0 : root()) || document.body)
  });
};
Popup.defaultProps = {
  prefixClass: "yk"
};
export default Popup;